/** main.js insait-frontend 엔트리 */
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import App from './App.vue';
import router from './router';
import { i18n } from './locales';
import { installErrorHandling } from './utils/appErrors';

import 'element-plus/dist/index.css';
// tui-grid CSS 는 @win/grid 가 캡슐화(마운트 시 자동 로드) - 여기선 winGrid 자체 스타일만 가져온다.
import '@win/grid/style.css';
import './assets/styles/index.css';

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

import { useThemeStore } from '@/stores/theme';
import { useLocaleStore } from '@/stores/locale';

const app = createApp(App).use(pinia).use(router).use(i18n);

// 화면 파일 불러오기 실패(배포 직후)와 처리하지 못한 화면 오류를 말없이 넘기지 않고 안내한다
installErrorHandling(app, router);

// theme store 의 persist 복원값을 DOM 에 즉시 반영 (mount 직전 - FOUC 최소화)
useThemeStore().applyCurrent();

// 복원된 언어의 리소스를 먼저 적재한 뒤 마운트한다(첫 화면이 다른 언어로 잠깐 보이는 것 방지).
useLocaleStore().applyCurrent().finally(() => app.mount('#app'));
